const getRandomNumberByDigit = (digit) => {
  if (!digit) throw Error('Please pass the digit of random number')
  let randomNum = Number(Math.random().toFixed(digit).slice(-digit))
  if (`${randomNum}`.length < digit) randomNum = `${randomNum}`.padEnd(digit, '1')
  return Number(randomNum)
}

export default getRandomNumberByDigit
